export default ({date}) => `<p class='title-prerelease'> ${window.html('accountHolds.prereleaseExpected', {date: date})}</p>`;
